// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hym9PQ45J1dmgECKqPL8 {
	width: 100%;
	height: 40px;
	padding: 0;
	margin: 0;
	border: none;
	background: transparent;
	outline: none;
}

.hym9PQ45J1dmgECKqPL8.eBJfh5NIpgih3N_Iog0L {
		animation: suJk7SknfqbYV45gsPty 0.1s;
	}

@keyframes suJk7SknfqbYV45gsPty {
	10%,
	90% {
		transform: translate3d(-1px, 0, 0);
	}

	20%,
	80% {
		transform: translate3d(2px, 0, 0);
	}

	30%,
	50%,
	70% {
		transform: translate3d(-4px, 0, 0);
	}

	40%,
	60% {
		transform: translate3d(4px, 0, 0);
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/Input/Input.pcss"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,YAAY;CACZ,UAAU;CACV,SAAS;CACT,YAAY;CACZ,uBAAuB;CACvB,aAAa;AAKd;;AAHC;EACC,oCAAqB;CACtB;;AAGD;CACC;;EAEC,kCAAkC;CACnC;;CAEA;;EAEC,iCAAiC;CAClC;;CAEA;;;EAGC,kCAAkC;CACnC;;CAEA;;EAEC,iCAAiC;CAClC;AACD","sourcesContent":[".input {\n\twidth: 100%;\n\theight: 40px;\n\tpadding: 0;\n\tmargin: 0;\n\tborder: none;\n\tbackground: transparent;\n\toutline: none;\n\n\t&.invalid {\n\t\tanimation: shake 0.1s;\n\t}\n}\n\n@keyframes shake {\n\t10%,\n\t90% {\n\t\ttransform: translate3d(-1px, 0, 0);\n\t}\n\n\t20%,\n\t80% {\n\t\ttransform: translate3d(2px, 0, 0);\n\t}\n\n\t30%,\n\t50%,\n\t70% {\n\t\ttransform: translate3d(-4px, 0, 0);\n\t}\n\n\t40%,\n\t60% {\n\t\ttransform: translate3d(4px, 0, 0);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `hym9PQ45J1dmgECKqPL8`,
	"invalid": `eBJfh5NIpgih3N_Iog0L`,
	"shake": `suJk7SknfqbYV45gsPty`
};
export default ___CSS_LOADER_EXPORT___;
